import React from 'react';
import { HiOutlineUser } from 'react-icons/hi';

/**
 * UserIcon
 * Ikona používateľa na označenie sekcií s osobnými údajmi.
 */
const UserIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineUser className={className} {...props} />
);

export default UserIcon;

